// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__rrN5Y","title":"styles_title__XVVAT","list":"styles_list__JFst1","form":"styles_form__PuN1f"};